import { Checkbox, Modal } from 'antd'
import { useEffect, useState } from 'react'

export default function AuditModal(props: {
    confirmEvt: (noApplication?: boolean) => void,
    closeEvt: () => void
    noApplication?: boolean,
    applicationName?: string
}) {
    const [noApplication, setNoApplication] = useState(false)
    useEffect(() => {
        if (props.noApplication) {
            setNoApplication(true)
        }
    }, [props.noApplication])
    const onConfirm = () => {
        props.confirmEvt(noApplication)
        props.closeEvt()
    }
  return <Modal
    title="温馨提示"
    visible
    okText="确认"
    cancelText="取消"
    onOk={onConfirm}
    onCancel={onConfirm}
    centered
  >
    <p style={{width: '100%'}}>{props.noApplication ? '没有上传过申请表，将无法处理与申请表比对的相关规则' : `已经上传报告抬头为${props.applicationName}的申请表，将以此申请表审核报告。若非此申请表，请先上传相应的申请表`}</p>
    <p>
        <Checkbox checked={noApplication} onChange={(e) => setNoApplication(e.target.checked)}>无申请表审核</Checkbox>
    </p>
  </Modal>
}
